import { SectionLoader } from '@/shared/components/section-loader';

export const AdminBiometricDevicesLoading = () => {
  return <SectionLoader />;
};
